const ALMIGHTY_REFERENCE_VERSION_KEYS = new Set([
    'WERYDANCE_2_5',
    'SEEDANCE_2_5',
    'WERYDANCE_2_0',
    'WERYDANCE_2_0_MINI',
    'WERYDANCE_2_0_FAST',
    'SEEDANCE_2_0',
    'SEEDANCE_2_0_MINI',
    'SEEDANCE_2_0_FAST',
])

const DURATION_SLIDER_MODEL_KEYS = new Set([
    'RUNWAY',
    'RUNWAY_4_5',
    'SEEDANCE_2_0',
    'SEEDANCE_2_0_MINI',
    'SEEDANCE_2_0_FAST',
    'WERYDANCE_2_0',
    'WERYDANCE_2_0_MINI',
    'WERYDANCE_2_0_FAST',
])

const normalizeCapabilityKey = (modelKey: string): string => {
    return modelKey.trim().toLowerCase().replace(/[\s._-]+/g, '')
}

export const isAlmightyReferenceSupported = (modelKey?: string): boolean => {
    if (!modelKey || typeof modelKey !== 'string') return false
    const key = modelKey.trim()
    if (ALMIGHTY_REFERENCE_VERSION_KEYS.has(key)) return true

    const normalized = key.toLowerCase().replace(/[\s._-]+/g, '')
    return (
        normalized === 'werydance25' ||
        normalized === 'werydance20' ||
        normalized === 'werydance20mini' ||
        normalized === 'werydance2' ||
        normalized === 'seedance25' ||
        normalized === 'seedance20' ||
        normalized === 'seedance20mini' ||
        normalized === 'seedance2'
    )
}

/** 判断 Seedance / Werydance 2.5 的模型键或分类键。 */
export const isDance25Model = (modelKey?: string): boolean => {
    if (!modelKey || typeof modelKey !== 'string') return false
    const normalized = modelKey.trim().toLowerCase().replace(/[\s._-]+/g, '')
    return normalized === 'seedance25' || normalized === 'werydance25'
}

/** 判断模型/版本是否使用时长滑块，仅控制控件展示。 */
export const isDurationSliderSupported = (modelKey?: string): boolean => {
    if (!modelKey || typeof modelKey !== 'string') return false
    const key = modelKey.trim()
    if (DURATION_SLIDER_MODEL_KEYS.has(key)) return true

    const normalized = normalizeCapabilityKey(key)
    return (
        normalized === 'runway' ||
        normalized === 'runway45' ||
        normalized === 'seedance20' ||
        normalized === 'seedance20mini' ||
        normalized === 'seedance20fast' ||
        normalized === 'werydance20' ||
        normalized === 'werydance20mini' ||
        normalized === 'werydance20fast'
    )
}
